import React from "react";

function Footer() {
  return (
    <React.Fragment>
      <div class="footer">
        &copy; 2023 An Open-source Project by <a href="#" target="_new">Ishwar Acharya</a>.
      </div>
    </React.Fragment>
  );
}

export default Footer;
